import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { OrdinalDateParse } from '../../adapters/ordinal-date-adapter';
import { ErrorCode, ErrorMessages } from '../../entities/global/error-codes';
import { EquipmentDetailsService } from '../../equipment-details/equipment-details.service';
import { ImplementSelectionFilter, JobsiteSelectionFilter } from '../../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../favourite-dialog/favourite-dialog.service';
import { RemoveImplementModalData } from '../../remove-implement-modal/remove-implement-modal';
import { GETInventoryService } from '../../services/inventory.service';
import { CustomerSelectItem, EquipmentSelectItem } from '../../setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../../setup-equipment/setup-equipment.service';
import { GenericIdName } from '../../setup-implement/setup-implement.model';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fecr-moveto-inventory',
  templateUrl: './fecr-moveto-inventory.component.html',
  styleUrls: ['./fecr-moveto-inventory.component.scss']
})
export class FecrMovetoInventoryComponent implements OnInit {
 // Drop-down lists
 customerList: CustomerSelectItem[] = [];
 jobsiteList: GenericIdName[] = [];
 equipmentList: EquipmentSelectItem[] = [];
 selectedCustomerList:number[]=[];
 selectedJobsiteList:number[]=[];
 selectedEquipmentList:number[]=[];

 implementList: GenericIdName[] = [];
 selectedCustomer: number;
 selectedJobsite: number; 
 selectedEquipment: number;
 selectedImplement:number;

 smu: number;
 cost: number=0;
 eventDate: Date;
 comment: string;
 removeImplementData: RemoveImplementModalData;
 ttDate: string = "Click here to select a date.";
 ttComment: string = "You may enter a maximum of 256 characters.";

 minDate: Date = new Date();
 maxDate: Date = new Date();
 savingChanges: boolean = false;
 ord: OrdinalDateParse = new OrdinalDateParse();
  constructor(private _equipmentService: GETSetupEquipmentService,public dialogRef: MatDialogRef<FecrMovetoInventoryComponent>,
    private _favouriteDialogService:FavouriteDialogService,public _moduleService: EquipmentDetailsService,
    public _inventoryService: GETInventoryService, public toastr: NotificationsService, vcr: ViewContainerRef) {
      
    }

  ngOnInit() {
    this.loadCustomers();

    this.removeImplementData = new RemoveImplementModalData();
    this.removeImplementData.cost=0;
    this.eventDate = new Date();
    this.removeImplementData.date = this.eventDate;
  }
  loadCustomers() {
    this._equipmentService.getCustomerList().subscribe(r => {
        this.customerList = r;
    });
}

loadJobsitesForCustomer() {
  if (this.selectedCustomer == null)
      return;
  this.selectedJobsite = null;
  this.jobsiteList = null;
  this.selectedEquipment = null;
  this.equipmentList = [];
  let arr = [];
  arr.push(this.selectedCustomer);
  this.selectedCustomerList = arr;
  var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomerList,
    }
  this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
      if (r) {
          this.jobsiteList = r;
      }
    });
}

  // Show the list of equipment for the selected jobsite.
  loadEquipmentForJobsite() {
    if (this.selectedJobsite == null)
        return;
    this.removeImplementData.jobsiteId = this.selectedJobsite;
        let arr_ = [];
        arr_.push(this.selectedJobsite)
        this.selectedJobsiteList = arr_;
    var params: number[] = this.selectedJobsiteList;
    this._favouriteDialogService.GetEquipmentAvailable(params).subscribe(r => {
        if (r) {
            this.equipmentList = r;
        }
    });
}

onSelectEquipment() {
  if (this.selectedEquipment != null) {
    this.smu = this.equipmentList.find(x=>x.Id==this.selectedEquipment).SMU;
      //this._equipmentId = this.selectedEquipment;
      this.removeImplementData.smu = this.smu;
      this.loadImplementsForEquipment();
  }
}

// Gets the list of implements that are currently loaded on the selected equipment.
loadImplementsForEquipment() {
  let arr_ = [];
  arr_.push(this.selectedEquipment)
this.selectedEquipmentList = arr_;
  var params: ImplementSelectionFilter = {
      Equipments: this.selectedEquipmentList,
      Customers:[],
      Jobsites:[],
    }
  this._favouriteDialogService.GetImplementsAvailable(params).subscribe(r => {
      if (r) {
          this.implementList = r;
      }
  });
}

onCloseClick(): void {
  this.dialogRef.close(false);
}
implementSelected(v) {
  this.removeImplementData.implementId = v;

  this._inventoryService.returnMinDateForImplementEvent(v)
    .subscribe(response => {
      if (response != "") {
        try {
          this.minDate = new Date(response);
        }
        catch (ex) {
          this.minDate = new Date();
        }
      }
    });
}

// Comment
commentChanged(): void {
  this.removeImplementData.comment = this.comment;
}
  // SMU
  smuChanged(): void {
    this.removeImplementData.smu = this.smu;
  }
  // Cost
  costChanged(): void {
    this.removeImplementData.cost = this.cost;
  }

  // Date
  dateChanged(): void {
    this.removeImplementData.date = this.eventDate;
    this.ord.formatDateOrdinal((this.eventDate.toString())
      .split(' ')
      .slice(1)
      .join(' '), false);
  }

saveChanges(): void {
this.removeImplementData.status = 3;
this.removeImplementData.equipmentId = this.selectedEquipment;
this.removeImplementData.repairerId = 0;
this.removeImplementData.workshopId=0;
  if(this.removeImplementData.cost == null ){
  this.removeImplementData.cost=0;
  }
  if(this.removeImplementData.comment == null ){
    this.removeImplementData.comment="";
    }
  console.log("removeImplementData", this.removeImplementData)
  let validation = this.validateData();
  console.log("removeImplementData", validation)
  this.savingChanges = true;

  if (validation == ErrorCode.VALIDATION_PASSED) {
    console.log("save")
   
    this._moduleService.saveRemoveImplement(this.removeImplementData).subscribe(response => {
      if (response == "false") {
        this.toastr.error(ErrorMessages.ERROR_SAVING);
        this.savingChanges = false;
      }
      else {
        this.dialogRef.close(true);
      }
    }, error => { console.log(error); });
  }
  else if (validation == ErrorCode.ERROR_NEGATIVE_COST) {
    this.toastr.error(ErrorMessages.ERROR_NEGATIVE_COST);
    this.savingChanges = false;
  }
  else if (validation == ErrorCode.ERROR_NEGATIVE_SMU) {
    this.toastr.error(ErrorMessages.ERROR_NEGATIVE_SMU);
    this.savingChanges = false;
  }
  else {
    this.toastr.error(ErrorMessages.ERROR_MISSING_FIELDS);
    this.savingChanges = false;
  }
}

validateData(): number {
  var returnCode = ErrorCode.VALIDATION_PASSED;

  if (this.removeImplementData.equipmentId
    && this.removeImplementData.jobsiteId
    && this.removeImplementData.smu
    && this.removeImplementData.cost
    && this.removeImplementData.date
    && this.removeImplementData.status
    && this.removeImplementData.comment) {
    if (this.removeImplementData.cost < 0) {
      returnCode = ErrorCode.ERROR_NEGATIVE_COST;
    }
    else if (this.removeImplementData.smu < 0) {
      returnCode = ErrorCode.ERROR_NEGATIVE_SMU;
    }
    // else if ((this.removeImplementData.repairerId == 0
    //     || this.removeImplementData.workshopId == 0)
    //     && this.showRepairerAndWorkshop) {
    //     returnCode = ErrorCode.ERROR_MISSING_FIELDS;
    // }
    else if (this.removeImplementData.cost == null) {
      returnCode = ErrorCode.ERROR_MISSING_FIELDS;
    }
    else {
      returnCode = ErrorCode.VALIDATION_PASSED;
    }
  }
  
  return returnCode;
}
}
